module.exports = __webpack_public_path__ + "static/android-chrome-512x512-b15ff2315a8705c8b008325c24bb2e56.png";